export const BUSINESS_REPORTS_FEATURE_PREFIX = 'business_reports'
